// core
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'documentsTemplate',
  templateUrl: './documents-template.component.html',
  styleUrls: ['./documents-template.component.scss']
})
export class DocumentsTemplateComponent implements OnInit {
  categories?: Array<any>;

  constructor(
    private route: ActivatedRoute  
  ) {}

  ngOnInit() {
    if (this.route.snapshot.data) {
      this.categories = this.route.snapshot.data.document?.categories || [];
    }
  }

  toggleActive($event: any) {
    $event.stopPropagation();
    const accordionItem = $event?.target.closest('.accordion-item');
    const accordionHeader = accordionItem?.querySelector('.accordion-header');

    if (accordionItem?.classList?.contains('active')) {
      accordionItem.classList.remove('active');
      accordionItem.classList.add('inactive');
      accordionHeader?.setAttribute('aria-expanded', 'false');
      // fallback for browsers that down support calc-size
      if (!CSS.supports("width: calc-size(auto, size)")) {
        const accordionContent = accordionItem.querySelector('.accordion-content');
        accordionContent.style.height = `0px`;
      }
    } else {
      accordionItem.classList.add('active');
      accordionItem.classList.remove('inactive');
      accordionHeader?.setAttribute('aria-expanded', 'true');
      // fallback for browsers that down support calc-size
      if (!CSS.supports("width: calc-size(auto, size)")) {
        const accordionContent = accordionItem.querySelector('.accordion-content');
        const accordionContentHeight = accordionContent.scrollHeight;
        accordionContent.style.height = `${accordionContentHeight}px`;
      }
    }
  }
}

